import * as places from './actions';
// import { Place } from './types';
// import { ActionType, getType } from 'typesafe-actions';
import { ActionType } from 'typesafe-actions';
import { Middleware } from 'redux';

export const fetchPlacesMiddleware: Middleware<{}> = ({ getState }) => next => async (action: ActionType<typeof places>) => {

  next(action);
  // if (action.type !== getType(places.updatePlaces))  {
  //   return;
  // }

  // next(places.fetchPlaces.request());
  // try {
  //   console.log('places---')
  //   // const fields = 'images,addresses,hours,addresses,contacts,directionsInfo,directionsUrl,entranceFees,entrancePasses,latLong,operatingHours,weatherInfo';
  //   // const response = await fetch('https://developer.nps.gov/api/v1/parks?limit=10&api_key=hd0FOAAs8bVbTmoq2rWGKLDCtyk3lGodivqRYy3w&fields=' + fields);
  //   const response = await fetch('/data/parks.min.json');
  //   const placeList: Place[] = (await response.json()).data;
  //   next(places.fetchPlaces.success(placeList));
  // } catch (e) {
  //   next(places.fetchPlaces.failure(e));
  // }
};
